import {OutfitSliderSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {Slot} from '@aboutyou/ui-components';
import React from 'react';
import {OutfitSlider} from '../../OutfitSlider/OutfitSlider';

interface OutfitSliderTileProps {
  className?: string;
  outfitSliderData: OutfitSliderSection;
  streamPosition: number;
  gridColumns?: number;
}

export const OutfitSliderTile: React.FC<OutfitSliderTileProps> = ({
  className,
  outfitSliderData,
  streamPosition,
  gridColumns,
}) => {
  if (!outfitSliderData) {
    return null;
  }

  return (
    <Slot columns={gridColumns} position={streamPosition} Comp="li">
      <OutfitSlider
        outfitSliderData={outfitSliderData}
        className={className}
        streamPosition={streamPosition}
      />
    </Slot>
  );
};
